import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import { Spacer, rem } from 'design-system';
import IconEnlarge from 'design-system/icons/IconEnlarge';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const EnlargeDocumentButton = ({ source }) => {
    const navigation = useMainStackNavigation();
    const onPress = useCallback(() => {
        navigation.navigateDeprecated('ViewImageScreen', { source });
    }, [source]);
    return (<TouchableBounce style={styles.enlargeBtn} onPress={onPress}>
      <IconEnlarge />
      <Spacer w={8}/>
      <Text Text-14 White>
        Enlarge document
      </Text>
    </TouchableBounce>);
};
export default EnlargeDocumentButton;
const styles = StyleSheet.create({
    enlargeBtn: {
        padding: rem(8),
        borderRadius: rem(8),
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: 'rgba(0,0,0,0.8)',
    },
});
